/*
 *
 * ForgotPassword constants
 *
 */

export const GET_FORGOT_PASSWORD_REQUEST_SENT = 'src/User/GET_FORGOT_PASSWORD_REQUEST_SENT';
export const GET_FORGOT_PASSWORD_REQUEST_SUCCEED = 'src/User/GET_FORGOT_PASSWORD_REQUEST_SUCCEED';
export const GET_FORGOT_PASSWORD_REQUEST_FAILED = 'src/User/GET_FORGOT_PASSWORD_REQUEST_FAILED';
export const ALTER_FORGOT_PASSWORD_REQUEST_SENT_FLAG = 'src/User/ALTER_FORGOT_PASSWORD_REQUEST_SENT_FLAG';
